import { defineMessages } from 'react-intl';

export default defineMessages({
    errorMessage: {
        id: 'quoteandbind.farm.views.farm-package-details.Something went wrong. Template was not downloaded. Please try again.',
        defaultMessage: 'Something went wrong. Template was not downloaded. Please try again.'
    },
    error: {
        id: 'quoteandbind.farm.views.farm-package-details.Error',
        defaultMessage: 'Error'
    },
    downloadQuoteTemplate: {
        id: 'quoteandbind.farm.views.farm-package-details.Download Blank Quote Template',
        defaultMessage: 'Download Blank Quote Template'
    },
    uploadQuoteTemplate: {
        id: 'quoteandbind.farm.views.farm-package-details.Upload Quote Template',
        defaultMessage: 'Upload Completed Quote Template'
    },
    uploadExcelTemplate: {
        id: 'quoteandbind.farm.views.farm-package-details.Download and Upload Quote Template',
        defaultMessage: 'Download and Upload Quote Template'
    },
    uploadExcelMessage: {
        id: 'quoteandbind.farm.views.farm-package-details.Upload Excel Functionality',
        defaultMessage: 'Upload Excel Functionality'
    },
    uploadExcelMessage: {
        id: 'quoteandbind.farm.views.farm-package-details.Unable to Quote the Policy.Unable to quote the policy. Please review the document for more details.',
        defaultMessage: 'Unable to quote the policy. Please review the document for more details.'
    },
    successMessage: {
        id: 'quoteandbind.farm.views.farm-package-details.Success',
        defaultMessage: 'Success'
    },
    successMessageInfo: {
        id: 'quoteandbind.farm.views.farm-package-details.Quote Processed Successfully.',
        defaultMessage: 'Quote Processed Successfully.'
    },
    uploadWaitMessage: {
        id: "gw-portals-policytransaction-common-angular.components.spreadsheetProcessor.Please wait while we upload the document.",
        defaultMessage: "Please wait while we upload the document."
    },
    downloadWaitMessage: {
        id: "gw-portals-policytransaction-common-angular.components.spreadsheetProcessor.Please wait while we download the template.",
        defaultMessage: "Please wait while we download the template."
    }
});
